import { connect } from 'react-redux';
import Component from './component';
import clubAction from '../../../actions/club';


export default connect(
  state => ({
    items: state.club.list.map(key => state.club.items[key])
  }),
  dispatch => ({
    fetch: () => dispatch(clubAction.fetchList())
  })
)(Component);



// WEBPACK FOOTER //
// ./src/components/Clubs/ClubSelector/index.js